<script lang="ts">
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import SbRichtext from '../components/sbRichtext.svelte';
	import Blok from '../blok.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: ISbRichtext;
			benefits: Array<ISbStoryData>;
			asset: Array<ISbStoryData>;
			cta: Array<ISbStoryData>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content}>
	<PageGrid16 margin>
		<div class="col-span-full text-brown-1 lg:col-start-2 lg:col-end-8">
			<div
				class="mb-3 text-balance text-[44px]/[108%] tracking-[-0.44px] lg:mb-8 lg:text-[64px]/[110%] lg:tracking-[-0.64px]"
			>
				<SbRichtext text={content.headline} />
			</div>

			<ul class="flex flex-col">
				{#each content.benefits as benefit}
					<Blok content={benefit} />
				{/each}
			</ul>

			{#each content.cta as cta}
				<div class="mb-2 mt-7 flex max-lg:hidden">
					<Blok content={cta} />
				</div>
			{/each}
		</div>

		<div class="col-span-full lg:col-span-7 lg:col-start-9">
			<div class="aspect-4/3 w-full overflow-hidden rounded-xl max-lg:mt-4 lg:h-full">
				{#each content.asset as asset}
					<Blok content={asset} />
				{/each}
			</div>
		</div>

		<div class="col-span-full mt-6 w-full lg:hidden">
			{#each content.cta as cta}
				<Blok content={cta} />
			{/each}
		</div>
	</PageGrid16>
</section>
